import { reactOnCms } from 'common/js/react_on_cms';
import Login from 'tenants/cccsyd/auth/login';
import ResetPassword from 'tenants/cccsyd/auth/reset_password';
import SetPassword from 'tenants/cccsyd/auth/set_password';

reactOnCms.register({
  ResetPassword,
  SetPassword,
  Login,
});
